// extracted by css-extract-rspack-plugin
export default {"menuButton":"ReasoningEffortPicker-module__menuButton__tjwVF","buttonName":"ReasoningEffortPicker-module__buttonName__FdsSS"};